import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from 'components/_UI/Button'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import { useAuth } from 'context/auth/Auth'
import { useUser } from 'context/user/User'
import paths from 'routes/paths'
import colors from 'theme/colors'
import { enterProducerPanel } from './enterProducerPanel'

/**
 * Resposta do link do e-mail de convite de equipe. Quem aceita sai daqui com
 * o botão que leva ao painel do produtor — o acesso já está liberado. Se a
 * equipe só liberou eventos específicos (sem o painel inteiro), o caminho é a
 * tela de validação.
 */
export default function TeamInviteAlert({ visible, data, onClose }) {
    const navigate = useNavigate()
    const { isAuth } = useAuth()
    const { user } = useUser()

    const accesses = user?.producer_panel_access || []
    const access = accesses.find((item) => String(item.producer_id) === String(data?.producerId)) || accesses[0]

    function openPanel() {
        onClose()
        enterProducerPanel(access)
    }

    function openCheckin() {
        onClose()
        navigate(paths.checkin)
    }

    function login() {
        onClose()
        navigate(paths.login)
    }

    return (
        <Modal isOpen={!!visible} closeButton={true} onClose={onClose}>
            {
                data?.type == 'accept' && (
                    <>
                        <Text name='normal' type='bold' color={colors.successLight}>
                            Convite aceito
                        </Text>

                        <Text color={colors.night}>
                            Parabéns! Agora você faz parte da equipe <b>"{data?.teamName}"</b>
                            {isAuth ? '. O acesso ao painel do produtor já está liberado pra você.' : '. Entre na sua conta para acessar o painel do produtor.'}
                        </Text>

                        {
                            !isAuth && (
                                <Button variant='lightBlue' category='roundedBorded' marginTop={'16px'} onClick={login}>
                                    Entrar
                                </Button>
                            )
                        }

                        {
                            isAuth && access && (
                                <Button variant='lightBlue' category='roundedBorded' marginTop={'16px'} onClick={openPanel}>
                                    Acessar painel do produtor
                                </Button>
                            )
                        }

                        {
                            isAuth && !access && user?.have_permission_to_checkin && (
                                <Button variant='lightBlue' category='roundedBorded' marginTop={'16px'} onClick={openCheckin}>
                                    Ir para a validação
                                </Button>
                            )
                        }
                    </>
                )
            }

            {
                data?.type == 'reject' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Convite recusado
                        </Text>

                        <Text color={colors.night}>
                            Você recusou o convite para entrar na equipe <b>"{data?.teamName}"</b>.
                        </Text>
                    </>
                )
            }

            {
                data?.type == 'error' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Ocorreu um erro
                        </Text>

                        <Text color={colors.night}>
                            Ocorreu um erro inesperado durante o seu convite, entre em contato com o responsável da equipe.
                        </Text>
                    </>
                )
            }
        </Modal>
    )
}
